<div class="login-container">
  <div class="login-panel">
    <div class="card">
      <!-- Title -->
      <div class="card-header">
        <h5 class="login-title">
          <b>{{ "change-password-title" | translate }}</b>
        </h5>
      </div>

      <!-- Logo -->
      <span class="logo-lg d-flex">
        <img class="img-fluid center" src="{{ logoUrl ? logoUrl : defaultImg }}" alt="Change Password Logo" />
      </span>

      <!-- Info message -->
      <span class="d-flex justify-content-center text-center marginTop">
        <b> {{ "change-password-description" | translate }} </b>
      </span>


      <!-- Form -->
      <div class="card-body">
        <!-- User -->
        <div class="form-group has-feedback">
          <input
            [(ngModel)]="username"
            name="username"
            class="form-control readonly-user-field"
            placeholder="{{ 'user' | translate }}..."
            autocomplete="username"
            readonly
          />
          <i class="fas fa-user form-control-feedback"></i>
        </div>

        <!-- New password -->
        <div class="form-group has-feedback">
          <input [(ngModel)]="newPassword" [type]="hideNew ? 'password' : 'text'" name="Password" class="form-control"
            placeholder="{{ 'new-password' | translate }}..." autocomplete="password" readonly
            onfocus="this.removeAttribute('readonly');" />
            <div class="user-form-password-icons">
              <i class="fas fa-info-circle info-icon" (mouseenter)="showPasswordRequeriments = true"
                (mouseleave)="showPasswordRequeriments = false">
              </i>
              @if (showPasswordRequeriments) {
                <span class="user-form-password-requeriments">
                  {{ "password-requeriment" | translate }}
                </span>
              }
              <i class="form-control-feedback pointer" [ngClass]="hideNew ? 'fas fa-lock' : 'fas fa-unlock'"
              (click)="hideNew = !hideNew"></i>
            </div>
          </div>

          <!-- Confirm password -->
          <div class="form-group has-feedback">
            <input [(ngModel)]="confirmPassword" [type]="hideConfirm ? 'password' : 'text'" name="confirmPassword"
              class="form-control" placeholder="{{ 'password-repeat' | translate }}..." autocomplete="new-password"
              readonly onfocus="this.removeAttribute('readonly');" />
              <i class="form-control-feedback pointer" [ngClass]="hideConfirm ? 'fas fa-lock' : 'fas fa-unlock'"
              (click)="hideConfirm = !hideConfirm"></i>
            </div>
            <!-- Submit button -->
            <div class="form-group change-password-buttons">
              <button class="btn btn-primary btn-block" [disabled]="!canSubmitChange()" (click)="submitPasswordChange()">
                {{ "update" | translate }}
              </button>
              <button class="btn btn-secondary btn-block" (click)="exit()">
                {{ "logout" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
